export default __webpack_public_path__ + "static/use-body-text-dont-383b8fb79a87260781304e78a7596e4ef49ace33497840585007eaaf950c19a0.png";